/* eslint-disable camelcase */
import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';
import { debounce } from 'lodash';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import { connect } from 'react-redux';
import CheckboxTree from 'react-checkbox-tree';
import BeatLoader from 'react-spinners/BeatLoader';
import { modalSelector } from '../../ducks/modal';
import { Input } from '../Shared';
import './index.scss';
import API_URL from "../../config/env"
import axios from "axios"
import qs from "qs"
import { apiUrl } from "../../api/lt-api"

const defaultDimensions = {
  dimension_width: [],
  dimension_height: [],
  dimension_depth: [],
};
const defaultBaseDimensions = {
  base_dimension_width: [],
  base_dimension_height: [],
  base_dimension_depth: [],
}

const firstSelectedFilter = {
  first_filter: ""
}

const dedupeTree = (nodes = [], seen = new Set()) =>
  nodes.reduce((acc, node) => {
    if (seen.has(node.value)) return acc;
    seen.add(node.value);
    const copy = { ...node };
    if (copy.children) copy.children = dedupeTree(copy.children, seen);
    acc.push(copy);
    return acc;
  }, []);

const FilterSidebar = ({ state, saveChanges, filters, source, urlSearch }) => {
  const apiUrl = API_URL.apiUrl
  const isProducts = source === 'products';
  const [actualFilter, setActualFilter] = useState({ ...state });
  const filterRef = useRef(actualFilter);
  const [baselineDimensions, setBaselineDimensions] = useState(defaultBaseDimensions);
  const [selectedDimensions, setSelectedDimensions] = useState(defaultDimensions);
  const [firstFilter, setFirstFilter] = useState(firstSelectedFilter);
  const [filtersSearch, setFiltersSearch] = useState(null);
  const [search, setSearch] = useState('');
  const dynamicKeys = ['categories', 'suppliers', 'colors', 'materials', 'countries', 'price_ranges', 'state_provinces', 'assembly_required', 'inventory'];
  const effectiveFilters = filtersSearch ?? filters;
  const filterCategories = Object.keys(effectiveFilters).filter((k) => !k.includes('currencies'));
  const [renderTreeCategories, setRenderTreeCategories] = useState(filterCategories.reduce((acc, key) => ({ ...acc, [key]: false }), {}));
  const [categoriesLoading, setCategoriesLoading] = useState(filterCategories.reduce((acc, key) => ({ ...acc, [key]: false }), {}));
  const [isDimensionsExpanded, setDimensionsExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const firstFilterFetchedRef = useRef(false);
  const token = JSON.parse(localStorage.getItem('token'));

  const fetchDimensions = useCallback(async () => {
    setLoading(true);
    axios({
      method: 'post',
      url: `${apiUrl}products/products_dimensions`,
      data: { categories: filterRef.current.categories || [] },
      crossDomain: true,
      withCredentials: true,
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: token ? `Bearer ${token}` : undefined,
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        const data = response.data;
        if (data && data.dimensions) {
          setBaselineDimensions( {
            base_dimension_width: data.dimensions.dimension_width,
            base_dimension_height: data.dimensions.dimension_height,
            base_dimension_depth: data.dimensions.dimension_depth,
          });
          setSelectedDimensions({
            dimension_width: data.dimensions.dimension_width,
            dimension_height: data.dimensions.dimension_height,
            dimension_depth: data.dimensions.dimension_depth,
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching dimensions:', error);
      });
  }, [apiUrl, actualFilter.categories]);


  const fetchFilters  = useCallback(async () => {
    setLoading(true);
    const current = filterRef.current;

    const payload = {};
    if (firstSelectedFilter.first_filter) {
      const key = firstSelectedFilter.first_filter;
      payload[key] = current[key] || [];
    } else {
      payload.categories = current.categories || [];
      payload.suppliers = current.suppliers || [];
      payload.materials = current.materials || [];
      payload.colors = current.colors || [];
      payload.state_provinces = current.state_provinces || [];
      payload.price_ranges = current.price_ranges || [];
    }

    // axios({
    //   method: 'post',
    //   url: `${apiUrl}products/products_filters`,
    //   data: payload,
    //   crossDomain: true,
    //   withCredentials: true,
    //   headers: {
    //     'Access-Control-Allow-Origin': '*',
    //     Authorization: token ? `Bearer ${token}` : undefined,
    //     'Content-Type': 'application/json',
    //   },
    // })
    //   .then(({ data }) => {
    //     if (data && data.filters) {
    //       const cleaned = {};
    //       Object.entries(data.filters).forEach(([key, nodes]) => {
    //         if (['categories', 'suppliers', 'colors', 'materials'].includes(key)) {
    //           cleaned[key] = dedupeTree(nodes);
    //         } else {
    //           cleaned[key] = nodes;
    //         }
    //       });
    //       setFiltersSearch(cleaned);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error('Error fetching filters:', error);
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //   });
  }, [apiUrl, actualFilter]);

  const saveActualFilter = useCallback((key, val) => {
    setActualFilter((prev) => {
      const next = fromJS({ ...prev, [key]: val }).toJS();
      filterRef.current = next;
      return next;
    });
  }, [fetchFilters]);

  const shouldFetchDynamic = nextFilter => {
    firstFilterFetchedRef.current = false;
    const pickedKeys = dynamicKeys.filter(
      (key) => Array.isArray(nextFilter[key]) && nextFilter[key].length > 0,
    );
    if (pickedKeys.length === 1) {
      firstSelectedFilter.first_filter = pickedKeys[0];
      setFirstFilter(firstSelectedFilter);
      return true;
    }
    return false;
  };

  const isActualFilterEmpty = (filter) =>
    dynamicKeys
      .filter((key) => Array.isArray(filter[key]))
      .every((key) => filter[key].length === 0);

  const disabled = JSON.stringify(actualFilter) === JSON.stringify(state);

  const filterObjectChildrenNodes = (
    nodes = [],
    searchValue = '',
    expandedCategories = []
  ) => {
    const term = searchValue.trim().toLowerCase();
    if (!term) return nodes;

    const matchesTerm = (label = '') =>
      label
        .toLowerCase()
        .split(/[\s-/]+/)
        .some(tok =>
          tok.startsWith(term) || tok.startsWith(`${term}s`)
        );

    return nodes
      .map(node => {
        if (!node) return undefined;

        if (matchesTerm(node.label)) {
          const children = node.children?.length
            ? filterObjectChildrenNodes(node.children, term, expandedCategories)
            : null;

          return { ...node, children };
        }

        if (node.children?.length) {
          const kids = filterObjectChildrenNodes(node.children, term, expandedCategories);
          if (kids.length) {
            expandedCategories.push(String(node.value)); // expand parent
            return { ...node, children: kids };
          }
        }

        return undefined;
      })
      .filter(Boolean);
  };


  const debounceSearchRef = useRef();
  if (!debounceSearchRef.current) {
     debounceSearchRef.current = debounce((searchValue) => {
       const normalizedSearch = searchValue.trim().toLowerCase();
       const expandedCategories = [];

       const filteredSearch = Object.keys(filters).reduce((acc, key) => ({
         ...acc,
         [key]: (key !== 'dimensions') ? filterObjectChildrenNodes(filters[key], normalizedSearch, expandedCategories) : {},
       }), {});

       setActualFilter({
         ...actualFilter,
         expandedCategories,
       });

       setFiltersSearch(
         searchValue ? filteredSearch : filters,
       );
     }, 300);
  }

  useEffect(() => {
    debounceSearchRef.current(search);
    return () => debounceSearchRef.current.cancel();
  }, [search]);

  useEffect(() => {
    filterRef.current = actualFilter;

  }, [actualFilter]);

  const wasEmptyRef = useRef(isActualFilterEmpty(actualFilter));

  useEffect(() => {
    const emptyNow = isActualFilterEmpty(actualFilter);
    if (emptyNow && !wasEmptyRef.current) {
      fetchFilters();
    }
    wasEmptyRef.current = emptyNow;
  }, [actualFilter, fetchFilters]);


  if (isProducts){
    useEffect(() => {
      const parsedQuery = qs.parse(urlSearch);
      const hasUrlDimensions =
        parsedQuery.dimension_width &&
        Array.isArray(parsedQuery.dimension_width) &&
        parsedQuery.dimension_width.length > 0 &&
        parsedQuery.dimension_height &&
        Array.isArray(parsedQuery.dimension_height) &&
        parsedQuery.dimension_height.length > 0 &&
        parsedQuery.dimension_depth &&
        Array.isArray(parsedQuery.dimension_depth) &&
        parsedQuery.dimension_depth.length > 0;

      const actualCategories = JSON.stringify(actualFilter.categories || []);
      const propCategories = JSON.stringify(state.categories || []);

      if (hasUrlDimensions && actualCategories === propCategories) {
        setSelectedDimensions({
          dimension_width: state.dimension_width,
          dimension_height: state.dimension_height,
          dimension_depth: state.dimension_depth,
        });
        setBaselineDimensions({
          base_dimension_width: state.base_dimension_width,
          base_dimension_height: state.base_dimension_height,
          base_dimension_depth: state.base_dimension_depth,
        })
        setActualFilter((prev) => ({
          ...prev,
          dimension_width: state.dimension_width,
          dimension_height: state.dimension_height,
          dimension_depth: state.dimension_depth,
          categories: state.categories,
        }));
      } else if (actualCategories !== propCategories) {
        setActualFilter((prev) => ({
          ...prev,
          categories: actualFilter.categories,
        }));

        setSelectedDimensions((prev) => ({
          ...prev,
          dimension_width: baselineDimensions.base_dimension_width,
          dimension_height: baselineDimensions.base_dimension_height,
          dimension_depth: baselineDimensions.base_dimension_depth,
        }));

        fetchDimensions();

        const needFirstFetch = firstSelectedFilter.first_filter && !firstFilterFetchedRef.current;
        const needRegularFetch = isActualFilterEmpty(actualFilter) || shouldFetchDynamic(actualFilter);

        if (needFirstFetch || needRegularFetch) {
          fetchFilters();
          if (needFirstFetch) firstFilterFetchedRef.current = true;
        }
      }
    }, [state.categories, actualFilter.categories]);
  }

  useEffect(() => {
    const actualSuppliers = JSON.stringify(actualFilter.suppliers || []);
    const propSuppliers = JSON.stringify(state.suppliers || []);
    const needFirstFetch = firstSelectedFilter.first_filter && !firstFilterFetchedRef.current;
    const needRegularFetch = isActualFilterEmpty(actualFilter) || shouldFetchDynamic(actualFilter);

    if (actualSuppliers !== propSuppliers){
      if (needFirstFetch || needRegularFetch) {
        fetchFilters();
        if (needFirstFetch) firstFilterFetchedRef.current = true;
      }
    }
  }, [state.suppliers, actualFilter.suppliers]);

  useEffect(() => {
    const actualAssemblyRequired = JSON.stringify(actualFilter.assembly_required || []);
    const propAssemblyRequired = JSON.stringify(state.assembly_required || []);
    const needFirstFetch = firstSelectedFilter.first_filter && !firstFilterFetchedRef.current;
    const needRegularFetch = isActualFilterEmpty(actualFilter) || shouldFetchDynamic(actualFilter);

    if (actualAssemblyRequired !== propAssemblyRequired) {
      if (needFirstFetch || needRegularFetch) {
        fetchFilters();
        if (needFirstFetch) firstFilterFetchedRef.current = true;
      }
    }
  }, [state.assembly_required, actualFilter.assembly_required]);


  useEffect(() => {
    const actualInventory = JSON.stringify(actualFilter.inventory || []);
    const propInventory = JSON.stringify(state.inventory || []);
    const needFirstFetch = firstSelectedFilter.first_filter && !firstFilterFetchedRef.current;
    const needRegularFetch = isActualFilterEmpty(actualFilter) || shouldFetchDynamic(actualFilter);

    if (actualInventory !== propInventory) {
      if (needFirstFetch || needRegularFetch) {
        fetchFilters();
        if (needFirstFetch) firstFilterFetchedRef.current = true;
      }
    }
  }, [state.inventory, actualFilter.inventory]);

  useEffect(() => {
    const actualColors = JSON.stringify(actualFilter.colors || []);
    const propColors = JSON.stringify(state.colors || []);
    const needFirstFetch = firstSelectedFilter.first_filter && !firstFilterFetchedRef.current;
    const needRegularFetch = isActualFilterEmpty(actualFilter) || shouldFetchDynamic(actualFilter);

    if (actualColors !== propColors){
      if (needFirstFetch || needRegularFetch) {
        fetchFilters();
        if (needFirstFetch) firstFilterFetchedRef.current = true;
      }
    }


  }, [state.colors, actualFilter.colors]);

  useEffect(() => {
    const actualMaterials = JSON.stringify(actualFilter.materials || []);
    const propMaterials = JSON.stringify(state.materials || []);
    const needFirstFetch = firstSelectedFilter.first_filter && !firstFilterFetchedRef.current;
    const needRegularFetch = isActualFilterEmpty(actualFilter) || shouldFetchDynamic(actualFilter);

    if (actualMaterials !== propMaterials){
      if (needFirstFetch || needRegularFetch) {
        fetchFilters();
        if (needFirstFetch) firstFilterFetchedRef.current = true;
      }
    }

  }, [state.materials, actualFilter.materials]);


  useEffect(() => {
    const actualStateProvinces = JSON.stringify(actualFilter.state_provinces || []);
    const propStateProvinces = JSON.stringify(state.state_provinces || []);
    const needFirstFetch = firstSelectedFilter.first_filter && !firstFilterFetchedRef.current;
    const needRegularFetch = isActualFilterEmpty(actualFilter) || shouldFetchDynamic(actualFilter);

    if (actualStateProvinces !== propStateProvinces){
      if (needFirstFetch || needRegularFetch) {
        fetchFilters();
        if (needFirstFetch) firstFilterFetchedRef.current = true;
      }
    }

  }, [state.state_provinces, actualFilter.state_provinces]);

  useEffect(() => {
    const norm = search.trim().toLowerCase();
    const expanded = [];
    const filtered = Object.keys(effectiveFilters).reduce((acc, key) => ({
      ...acc,
      [key]:
        key !== 'dimensions'
          ? filterObjectChildrenNodes(effectiveFilters[key], norm, expanded)
          : {},
    }), {});
    setActualFilter((p) => ({ ...p, expandedCategories: expanded }));
    setFiltersSearch(norm ? filtered : null);
  }, [search, filters]);

  useEffect(() => {
    setActualFilter((prev) => ({
      ...prev,
      dimension_width: selectedDimensions.dimension_width,
      dimension_height: selectedDimensions.dimension_height,
      dimension_depth: selectedDimensions.dimension_depth,
      base_dimension_width: baselineDimensions.base_dimension_width,
      base_dimension_depth: baselineDimensions.base_dimension_depth,
      base_dimension_height: baselineDimensions.base_dimension_height,
    }));

  }, [selectedDimensions, baselineDimensions]);

  const handleAccordionChange = (expandedUuids) => {
    if (expandedUuids.includes('dimensions') && !isDimensionsExpanded) {
      setDimensionsExpanded(true);

      const parsedQuery = qs.parse(urlSearch, { ignoreQueryPrefix: true });
      const hasUrlDimensions =
        parsedQuery.dimension_width &&
        Array.isArray(parsedQuery.dimension_width) &&
        parsedQuery.dimension_width.length > 0 &&
        parsedQuery.dimension_height &&
        Array.isArray(parsedQuery.dimension_height) &&
        parsedQuery.dimension_height.length > 0 &&
        parsedQuery.dimension_depth &&
        Array.isArray(parsedQuery.dimension_depth) &&
        parsedQuery.dimension_depth.length > 0;

      const actualCategories = JSON.stringify(actualFilter.categories || []);
      const propCategories = JSON.stringify(state.categories || []);

      if (!(hasUrlDimensions && actualCategories === propCategories)) {
        setSelectedDimensions((prev) => ({
          ...prev,
          dimension_width: baselineDimensions.base_dimension_width,
          dimension_height: baselineDimensions.base_dimension_height,
          dimension_depth: baselineDimensions.base_dimension_depth,
        }));

        fetchDimensions();
      }
    }
  };

  const renderCategories = useMemo(() => ({
    quality_rating: (
      <div className="filter-sidebar__ranges">
        <div className="filter-sidebar__inputs">
          <Input
            name="minRating"
            type="text"
            placeholder="Min"
            value={actualFilter.quality_rating?.[0] || ''}
            onChange={(event) => setActualFilter({
              ...actualFilter,
              quality_rating: [event.target.value, actualFilter?.quality_rating?.[1]],
            })}
          />
          -
          <Input
            name="maxRating"
            type="text"
            placeholder="Max"
            value={actualFilter.quality_rating?.[1] || ''}
            onChange={(event) => setActualFilter({
              ...actualFilter,
              quality_rating: [actualFilter?.quality_rating?.[0], event.target.value],
            })}
          />
        </div>
      </div>
    ),
    dimension_width: (
      <div className="filter-sidebar__dimensions_ranges">
        <label>Width</label>
        <Slider
          range
          step={1}
          min={Number(baselineDimensions.base_dimension_width[0])}
          max={Number(baselineDimensions.base_dimension_width[1])}
          value={[
            Number(selectedDimensions.dimension_width[0]),
            Number(selectedDimensions.dimension_width[1]),
          ]}
          onChange={(newValue) =>
            setSelectedDimensions((prev) => ({
              ...prev,
              dimension_width: newValue,
            }))
          }
        />
        <div className="filter-sidebar__range-values">
          <div className="filter-sidebar__range-min-wrapper">
            <span className="filter-sidebar__range-min-value">
              {Number(selectedDimensions.dimension_width[0]) + '"'}
            </span>
          </div>
          <div className="filter-sidebar__range-delimiter-wrapper">
            <span className="filter-sidebar__range-delimiter">
              —
            </span>
          </div>
          <div className="filter-sidebar__range-max-wrapper">
            <span className="filter-sidebar__range-max-value">
              {Number(selectedDimensions.dimension_width[1]) + '"'}
            </span>
          </div>
        </div>
      </div>
    ),
    dimension_height: (
      <div className="filter-sidebar__dimensions_ranges">
        <label>Height</label>
        <Slider
          range
          step={1}
          min={Number(baselineDimensions.base_dimension_height[0])}
          max={Number(baselineDimensions.base_dimension_height[1])}
          value={[
            Number(selectedDimensions.dimension_height[0]),
            Number(selectedDimensions.dimension_height[1]),
          ]}
          onChange={(newValue) =>
            setSelectedDimensions((prev) => ({
              ...prev,
              dimension_height: newValue,
            }))
          }
        />
        <div className="filter-sidebar__range-values">
          <div className="filter-sidebar__range-min-wrapper">
            <span className="filter-sidebar__range-min-value">
              {Number(selectedDimensions.dimension_height[0]) + '"'}
            </span>
          </div>
          <div className="filter-sidebar__range-delimiter-wrapper">
            <span className="filter-sidebar__range-delimiter">
              —
            </span>
          </div>
          <div className="filter-sidebar__range-max-wrapper">
            <span className="filter-sidebar__range-max-value">
              {Number(selectedDimensions.dimension_height[1]) + '"'}
            </span>
          </div>
        </div>
      </div>
    ),
    dimension_depth: (
      <div className="filter-sidebar__dimensions_ranges">
        <label>Depth</label>
        <Slider
          range
          step={1}
          min={Number(baselineDimensions.base_dimension_depth[0])}
          max={Number(baselineDimensions.base_dimension_depth[1])}
          value={[
            Number(selectedDimensions.dimension_depth[0]),
            Number(selectedDimensions.dimension_depth[1]),
          ]}
          onChange={(newValue) =>
            setSelectedDimensions((prev) => ({
              ...prev,
              dimension_depth: newValue,
            }))
          }
        />
        <div className="filter-sidebar__range-values">
          <div className="filter-sidebar__range-min-wrapper">
            <span className="filter-sidebar__range-min-value">
              {Number(selectedDimensions.dimension_depth[0]) + '"'}
            </span>
          </div>
          <div className="filter-sidebar__range-delimiter-wrapper">
            <span className="filter-sidebar__range-delimiter">
              —
            </span>
          </div>
          <div className="filter-sidebar__range-max-wrapper">
            <span className="filter-sidebar__range-max-value">
              {Number(selectedDimensions.dimension_depth[1]) + '"'}
            </span>
          </div>
        </div>
      </div>
    ),
  }), [actualFilter, baselineDimensions, selectedDimensions]);

  const buildNodes = (category) => {
    const raw = effectiveFilters?.[category] || [];
    if (category === 'state_provinces') {
      return raw.map(country => ({

        label: country.label,
        value: country.label,
        children: (country.children || []).map(state => ({
          label: state.label,
          value: state.value,
        })),
      }));
    }
    if (category === 'assembly_required') {
      return raw.map(item => ({
        label: item.label,
        value: item.value,
      }));
    }
    if (category === 'inventory') {
      return raw.map(item => ({
        label: item.label,
        value: item.value,
      }));
    }
    return raw;
  };

  const renderCheckCategories = useMemo(() =>
    filterCategories.map((category) => {
      const nodes = buildNodes(category);

      const title = category === 'state_provinces'
        ? 'Locations'
        : (category.charAt(0).toUpperCase() + category.slice(1)).replace('_', ' ');

      return (
        <AccordionItem key={category} onClick={() => {
          const needFirstFetch = firstSelectedFilter.first_filter && !firstFilterFetchedRef.current && category !== 'dimensions';
          const needRegularFetch = isActualFilterEmpty(actualFilter) || shouldFetchDynamic(actualFilter);

          if (needFirstFetch) {
            fetchFilters();
            if (needFirstFetch) firstFilterFetchedRef.current = true;
          }
          setCategoriesLoading({ ...categoriesLoading, [category]: true });
          setTimeout(() => {
            setRenderTreeCategories({ ...renderTreeCategories, [category]: !renderTreeCategories[category] });
            setCategoriesLoading({ ...categoriesLoading, [category]: false });
          }, 0);
        }}>
          <AccordionItemHeading>
            <AccordionItemButton>
              {title}
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>
            <div className="filter-sidebar__content">
              {categoriesLoading[category] && (
                <div className="filter-sidebar__loader">
                  <BeatLoader color="#000" />
                </div>
              )}
              {nodes.length === 0 ? (
                <p className="filter-sidebar__empty">No options available</p>
              ) : (
                <CheckboxTree
                  nodes={nodes}
                  checked={actualFilter[category]}
                  expanded={actualFilter.expandedCategories}
                  expandOnClick
                  onlyLeafCheckboxes={false}
                  onCheck={(value) => saveActualFilter(category, value)}
                  onExpand={(value) => saveActualFilter('expandedCategories', value)}
                />
              )}
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      );
    }), [effectiveFilters, actualFilter, filtersSearch, renderTreeCategories, categoriesLoading]);

  return (
    <div className="filter-sidebar">
      <button
        disabled={disabled}
        className="filter-sidebar__button"
        onClick={async () => {
          await saveChanges(actualFilter);
        }}
      >
        Apply filters
      </button>
      <Input
        name="filters"
        type="text"
        placeholder="Search filters"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
      />
      <Accordion
        allowMultipleExpanded
        allowZeroExpanded
        onChange={handleAccordionChange}
      >
        {renderCheckCategories}
        {isProducts ? (
          <AccordionItem uuid="dimensions">
            <AccordionItemHeading>
              <AccordionItemButton>
                Product Dimensions
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              {loading ? (
                <div className="filter-sidebar__loader">
                  <BeatLoader color="#000" />
                </div>
              ) : (
                <>
                  {renderCategories.dimension_width}
                  {renderCategories.dimension_height}
                  {renderCategories.dimension_depth}
                </>
              )}
            </AccordionItemPanel>
          </AccordionItem>
          ): null
        }
      </Accordion>
    </div>
  );
};

FilterSidebar.propTypes = {
  filters: PropTypes.shape({
    [PropTypes.string]: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })),
  }).isRequired,
  saveChanges: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  source: PropTypes.string.isRequired,
};

export default connect(
  (state) => modalSelector(state),
)(FilterSidebar);
